import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AutoSaveInputLabel from '../../../../../../components/form/AutoSaveInputLabel';
import { FormGroup } from '../../../../../../components/form/FormGroup';
import { SelectDropdown } from '../../../../../../components/Select/SelectDropdown';
import { OptionBase } from '../../../../../../components/Select/types';
import { getGoalTypeStr } from '../translations';
import { GoalType } from '../types';
import { ObjectiveFormData } from './types';
import { useGoalFormContext } from './goalFormState';

const i18prefix = 'performanceReview.goals2.goalSidebar';

type Props = {
  isDisabled?: boolean;
};

export const GoalCreateTypeField: React.FC<Props> = ({ isDisabled }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useGoalFormContext<ObjectiveFormData>();

  return (
    <Row>
      <Col>
        <FormGroup data-field="type">
          <AutoSaveInputLabel label={t(`${i18prefix}.formFields.type`)} />
          <SelectDropdown
            value={values.type}
            onChange={(val) => setFieldValue('type', val as GoalType)}
            options={goalOptions}
            isDisabled={isDisabled}
            heightMode="large"
          />
        </FormGroup>
      </Col>
      <Col>&nbsp;</Col>
    </Row>
  );
};

const creatGoalTypeOption = (value: GoalType): OptionBase => ({
  value,
  label: getGoalTypeStr(value),
});

const goalOptions = [
  creatGoalTypeOption('employee'),
  creatGoalTypeOption('team'),
];
